import React from 'react';
import Button from "./Button";

const RedButton = ({title, icon, fill, type, disabled, onClick}) => {
    return (
        <Button classType="Red" title={title} icon={icon !== undefined && icon} fill={fill} type={type} disabled={disabled} onClick={onClick} />
    );
};

export default RedButton;